import { Component, Host, h, Element, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-richtext',
    styleUrl: 'sew-ws-richtext.scss',
    shadow: false,
})
export class SewWsRichtext {
    @Element() host: HTMLSewWsRichtextElement;

    @Prop({ reflect: true }) large: boolean;
    @Prop({ reflect: true }) small: boolean;

    private checkIfBelowRichtext(): void {
        const previousSibling = this.host.previousElementSibling;

        // if there is a node add margin for small and large size
        if (
            previousSibling &&
            (previousSibling.nodeName === 'SEW-WS-RICHTEXT' ||
                previousSibling.nodeName === 'SEW-WS-PODCAST') &&
            this.host.getAttribute('slot') === previousSibling.getAttribute('slot')
        ) {
            this.host.classList.add('margin-top');
        }
    }

    private checkForListIcon(): void {
        this.host.querySelectorAll('ul[data-icon]').forEach(ul => {
            const icon = ul.getAttribute('data-icon');
            ul.querySelectorAll('li').forEach(li => {
                li.insertAdjacentHTML('afterbegin', `<sew-icon icon="${icon}"></sew-icon>`);
            });
        });
    }

    componentWillLoad() {
        this.checkIfBelowRichtext();
        this.checkForListIcon();

        this.host.querySelectorAll('a').forEach(el => {
            el.addEventListener('click', e => {
                e.stopPropagation();
            });
        });
    }

    render() {
        return (
            <Host>
                <slot></slot>
            </Host>
        );
    }
}
